import { ReactifySearchProviderProps } from "../components";
import { Config, ConfigCuration } from "../types";

export const getCuration = (options: {
  provider: ReactifySearchProviderProps;
  config: Config;
  searchTerm?: string;
}) => {
  const handleOrSearchTerm = options.provider.mode === "collection" ? options.provider.collectionHandle : options.searchTerm ?? "";

  const normalisedHandleOrSearchTerm = handleOrSearchTerm
    .toLowerCase()
    .trim();

  const globalCuration = options.config.curations.find((curation) => {
    if (options.provider.mode === "search") {
      if (options.provider.market) {
        return curation.id === `global_${options.provider.market}_search`;
      } else {
        return curation.id === "global_search";
      }
    }
    if (options.provider.mode === "instant-search") {
      if (options.provider.market) {
        return curation.id === `global_${options.provider.market}_search`;
      } else {
        return curation.id === "global_search";
      }
    }
    if (options.provider.mode === "collection") {
      if (options.provider.market) {
        return curation.id === `global_${options.provider.market}_collection`;
      } else {
        return curation.id === "global_collection";
      }
    }
    return false;
  });

  const curation = options.config.curations.find((curation) => {
    if (options.provider.market) {
      if (curation.markets && !curation.markets.includes(options.provider.market)) {
        return false;
      }
    }

    const normalisedSearchTerm = curation.searchTerm?.toLowerCase().trim();
    const normalisedCollectionHandle = curation.collectionHandle
      ?.toLowerCase()
      .trim();

    if ("instant-search" === options.provider.mode) {
      return (
        "search" === curation.type &&
        normalisedHandleOrSearchTerm === normalisedSearchTerm
      );
    }

    if ("search" === options.provider.mode) {
      return (
        "search" === curation.type &&
        normalisedHandleOrSearchTerm === normalisedSearchTerm
      );
    }

    if ("collection" === options.provider.mode) {
      return (
        "collection" === curation.type &&
        normalisedHandleOrSearchTerm === normalisedCollectionHandle
      );
    }

    return false;
  });

  const addGlobalBoosting = (curation: ConfigCuration) => {
    if (!globalCuration) {
      return curation;
    }

    const curationIsCollection = curation.type === "collection";
    if (!curationIsCollection) {
      return curation;
    }

    const curationHasRules =
      !!curation.boosting.groupings.length ||
      !!curation.boosting.sortings.length;

    if (curationHasRules) {
      return curation;
    }

    const curationWithGlobalBoosting = {
      ...curation,
      boosting: globalCuration.boosting,
    } as ConfigCuration;

    return curationWithGlobalBoosting;
  };

  if (curation) {
    return addGlobalBoosting(curation);
  }

  if (globalCuration) {
    return globalCuration;
  }

  return undefined;
}